
//2
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "typography4273996867",
    {"root":"typography4273996867--root","fontsFallback":"'\"Helvetica Neue\", \"Helvetica\", \"Arial\", \"メイリオ\", \"meiryo\", \"ヒラギノ角ゴ pro w3\", \"hiragino kaku gothic pro\", \"sans-serif\"'","fontUltraThin":"'\"HelveticaNeueW01-UltLt\", \"HelveticaNeueW02-UltLt\", \"HelveticaNeueW10-25UltL\", value(fontsFallback)'","fontThin":"'\"HelveticaNeueW01-Thin\", \"HelveticaNeueW02-Thin\", \"HelveticaNeueW10-35Thin\", value(fontsFallback)'","fontLight":"'\"HelveticaNeueW01-45Ligh\", \"HelveticaNeueW02-45Ligh\", \"HelveticaNeueW10-45Ligh\", value(fontsFallback)'","fontRoman":"'\"HelveticaNeueW01-55Roma\", \"HelveticaNeueW02-55Roma\", \"HelveticaNeueW10-55Roma\", value(fontsFallback)'","fontMedium":"'\"HelveticaNeueW01-65Medi\", \"HelveticaNeueW02-65Medi\", \"HelveticaNeueW10-65Medi\", value(fontsFallback)'","fontBold":"'\"HelveticaNeueW01-75Bold\", \"HelveticaNeueW02-75Bold\", \"HelveticaNeueW10-75Bold\", value(fontsFallback)'"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-backoffice/dist/src/typography.st.css
// module id = 499
// module chunks = 0